import { render } from "./TermsOfUse.vue?vue&type=template&id=5df9fea8&ts=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=ts"
export * from "./TermsOfUse.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__